import { h, Component } from 'preact'
import tdlib from '../../utils/tdlib'
import { Input } from '../../UI/Input'
import ImageLoader from '../../UI/ImageLoader'
import AuthStep from '../AuthStep'
import s from './RegisterForm.css'
import { Button } from '../../UI/Button'

interface iState {
  isLoading: boolean
  firstName: string
  lastName: string
  photo: File | null
}

class RegisterForm extends Component<{}, iState> {
  state = {
    isLoading: false,
    firstName: '',
    lastName: '',
    photo: null
  }

  onChangeInput = (e: Event) => {
    const { value, name } = e.target as HTMLInputElement

    this.setState({
      [name]: value
    })
  }

  onChangeImage = (photo: File | null) => {
    this.setState({ photo })
  }

  submitForm = async (e: Event) => {
    e.preventDefault()
    const {
      firstName,
      lastName,
      photo
    } = this.state

    this.setState({
      isLoading: true
    })

    try {
      await tdlib.send({
        '@type': 'registerUser',
        first_name: firstName,
        last_name: lastName
      })

      if (photo) {
        await tdlib.send({
          '@type': 'setProfilePhoto',
          photo: photo!
        })
      }
    } catch (err) {
      this.setState({
        isLoading: false
      })
      console.warn('RegisterError: ', err)
    }

  }

  render () {
    const {
      isLoading,
      firstName,
      lastName,
      photo
    } = this.state

    return (
      <AuthStep
        image={(
          <ImageLoader
            className={s.RegisterForm__photo}
            file={photo}
            onChange={this.onChangeImage}
          />
        )}
        title="Your Name"
        text={(
          `Enter your name and add
          a profile picture`
        )}
      >
        <form
          className={s.RegisterForm}
          onSubmit={this.submitForm}
        >
          <Input
            className={s.RegisterForm__field}
            label="Name"
            onInput={this.onChangeInput}
            value={firstName}
            name="firstName"
            autoFocus
          />

          <Input
            className={s.RegisterForm__field}
            label="Last Name (optional)"
            onInput={this.onChangeInput}
            value={lastName}
            name="lastName"
          />

          {firstName && (
            <Button
              className={s.RegisterForm__submit}
              isLoading={isLoading}
            >
              Start messaging
            </Button>
          )}
        </form>
      </AuthStep>
    )
  }
}

export default RegisterForm
